<template>
	<div class="drawer">
		<el-drawer
		size="1000px"
		title="宠物过敏史"
		:visible.sync="drawerStatus"
		@close='close'
		>
			<div class="drawerContent">
				<div style="height: 100%;overflow: auto;">
					<el-table class="table" :data="list" style="width: 100%;padding:0;">
						<el-table-column label="药品名称" min-width="200" prop="goodsName">
							<template slot-scope="props">
								{{props.row.allergyGoods.goodsName}}
							</template>
						</el-table-column>
						<!-- <el-table-column label="规格" min-width="250" prop="goodsName">
							<template slot-scope="props">
								{{props.row.allergyGoods.goodsName}}
							</template>
						</el-table-column> -->
						<el-table-column label="用量" min-width="160" prop="goodsName">
							<template slot-scope="props">
								{{props.row.allergyGoods.count}}
								{{props.row.allergyGoods.unit}}
								{{props.row.allergyGoods.goodsDosage}}
								{{props.row.allergyGoods.outUnit}}
							</template>
						</el-table-column>
						<el-table-column label="用法" min-width="160" prop="goodsName">
							<template slot-scope="props">
								<span v-if="props.row.allergyGoods.goodsUsage.length===5">
									{{props.row.allergyGoods.goodsUsage[0]}} {{props.row.allergyGoods.goodsUsage[1]}}天{{props.row.allergyGoods.goodsUsage[2]}}次 每次{{props.row.allergyGoods.goodsUsage[3]}}{{props.row.allergyGoods.goodsUsage[4]}}
								</span>
								<span v-else>无</span>
							</template>
						</el-table-column>
						<el-table-column label="过敏反应" min-width="160" prop="goodsName">
							<template slot-scope="props">
								<span v-for="(item,index) in props.row.symptom" :key="index">
									{{item}}
								</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="btnBox">
					<div class="btnItem" @click="close">取消</div>
					<div class="btnItem submit" @click="submit">确定</div>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				
				list:[],
				
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.yiliaoxin.userInfo
			},
			curPetInfo(){
				let obj = this.$store.getters["yiliaoxin/curPetInfo"]
				return obj
			},
		},
		props:{
		},
		mounted() {
			this.$nextTick(()=>{
				this.drawerStatus=true
			})
			this.getList()
		},
		methods: {
			close(){
				this.$emit("submit",{type:'close'})
			},
			// 保存基本信息
			submit() {
				this.$emit("submit",{type:'success'})
			},
			getList(){
				if(this.$public.isNull(this.curPetInfo._id)){
					this.list = []
					return 
				}
				let params = {
					petId:this.curPetInfo._id,
					goodsId:'',
				}
				let loading = this.$loading()
				this.$http.get('/api/Case/AllergyHistory/List', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.list = res.data
					}
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		::v-deep .el-drawer{
			.el-drawer__header{
				margin-bottom: 10px;
			}
			.el-drawer__body{
				height: calc(100% - 54px);
			}
		}
	}
	.drawerContent{
		height: 100%;padding-bottom:40px;box-sizing: border-box;
		.btnBox{
			width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
			.btnItem{
				text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
				&.submit{
					background-color: $mainColor;
				}
			}
		}
	}
</style>
